export function formatCurrency(amount) {
  if (typeof amount !== 'number' || isNaN(amount)) return 'Rp 0';
  return new Intl.NumberFormat('id-ID', {
    style: 'currency', currency: 'IDR', minimumFractionDigits: 0,
  }).format(amount);
}

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return dateStr; }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    return d.toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return dateStr; }
}

export const STATUS_CONFIG = {
  // laundry
  masuk:             { bg: 'bg-blue-100',   text: 'text-blue-700',   border: 'border-blue-400',   dot: 'bg-blue-500',   label: { id: 'Masuk',             en: 'Received'    } },
  proses_cuci:       { bg: 'bg-yellow-100', text: 'text-yellow-700', border: 'border-yellow-400', dot: 'bg-yellow-500', label: { id: 'Diproses',          en: 'Processing'  } },
  siap_diambil:      { bg: 'bg-emerald-100',text: 'text-emerald-700',border: 'border-emerald-400',dot: 'bg-emerald-500',label: { id: 'Siap Diambil',      en: 'Ready'       } },
  selesai:           { bg: 'bg-slate-100',  text: 'text-slate-600',  border: 'border-slate-300',  dot: 'bg-slate-400',  label: { id: 'Selesai',           en: 'Done'        } },
  // rental
  serah_terima:      { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-400', dot: 'bg-purple-500', label: { id: 'Serah Terima',      en: 'Handover'    } },
  sedang_disewa:     { bg: 'bg-yellow-100', text: 'text-yellow-700', border: 'border-yellow-400', dot: 'bg-yellow-500', label: { id: 'Sedang Disewa',     en: 'In Use'      } },
  // servis
  diagnosa:          { bg: 'bg-orange-100', text: 'text-orange-700', border: 'border-orange-400', dot: 'bg-orange-500', label: { id: 'Diagnosa',          en: 'Diagnosis'   } },
  sedang_dikerjakan: { bg: 'bg-yellow-100', text: 'text-yellow-700', border: 'border-yellow-400', dot: 'bg-yellow-500', label: { id: 'Sedang Dikerjakan', en: 'In Progress' } },
  // mua / penjahit
  konfirmasi:        { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-400', dot: 'bg-purple-500', label: { id: 'Dikonfirmasi',      en: 'Confirmed'   } },
};

export const PAYMENT_STATUS_CONFIG = {
  unpaid: { bg: 'bg-red-100', text: 'text-red-600', label: { id: 'Belum Bayar', en: 'Unpaid' } },
  partial: { bg: 'bg-orange-100', text: 'text-orange-600', label: { id: 'DP', en: 'Partial' } },
  paid: { bg: 'bg-green-100', text: 'text-green-700', label: { id: 'Lunas', en: 'Paid' } },
};

export function StatusBadge({ status, lang = 'id', size = 'sm' }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.masuk;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full ${size === 'sm' ? 'text-xs' : 'text-sm'} font-medium ${config.bg} ${config.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
      {config.label[lang]}
    </span>
  );
}

export function PaymentBadge({ status, lang = 'id' }) {
  const config = PAYMENT_STATUS_CONFIG[status] || PAYMENT_STATUS_CONFIG.unpaid;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {config.label[lang]}
    </span>
  );
}

export function formatApiError(error) {
  const detail = error?.response?.data?.detail || error?.message;
  if (!detail) return 'Terjadi kesalahan';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || String(e)).filter(Boolean).join(', ');
  return String(detail);
}

export function Spinner({ size = 'md', className = '' }) {
  const s = size === 'sm' ? 'w-4 h-4 border-2' : size === 'lg' ? 'w-10 h-10 border-4' : 'w-6 h-6 border-2';
  return <div className={`${s} border-slate-200 border-t-[#0f6c44] rounded-full animate-spin ${className}`} />;
}

export function PageLoader() {
  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <Spinner size="lg" />
        <p className="text-slate-500 text-sm">Memuat...</p>
      </div>
    </div>
  );
}
